import { useEffect, useState } from 'react';

import { courseMetadataApi } from '../api';
import type { CourseData } from '../types';

export function useCoursePreview(courseID: string | undefined) {
  const [courseInfo, setCourseInfo] = useState<CourseData>({} as CourseData);
  const [courseInfoLoaded, setCourseInfoLoaded] = useState<boolean>(false);
  const [courseInfoErrorStatus, setCourseInfoErrorStatus] = useState<number | null>(null);
  const [trackedCourseID, setTrackedCourseID] = useState<string | undefined>(courseID);

  // Reset synchronously on courseID change so consumers never observe stale
  // data/error from a previous fetch. (https://react.dev/reference/react/useState#storing-information-from-previous-renders)
  if (courseID !== trackedCourseID) {
    setTrackedCourseID(courseID);
    setCourseInfo({} as CourseData);
    setCourseInfoLoaded(false);
    setCourseInfoErrorStatus(null);
  }

  useEffect(() => {
    if (!courseID) {
      return;
    }
    courseMetadataApi.getCourseMeta(
      courseID,
      (data) => {
        setCourseInfo(data);
        setCourseInfoLoaded(true);
      },
      (err) => {
        setCourseInfoErrorStatus((err as { status?: number })?.status ?? null);
        setCourseInfoLoaded(true);
      },
    );
  }, [courseID]);

  return { courseInfo, courseInfoLoaded, courseInfoErrorStatus };
}
